"use client";

import Button from "../atoms/Button";
import InfoBanner from "../atoms/InfoBanner";
import { useVerification } from "../context/VerificationContext";

/**
 * @component EmailVerificationBanner
 * @description Persistent top-of-dashboard banner shown when the user's email
 * is not yet verified. Renders nothing while loading or when already verified.
 * CTA navigates to the resend flow at /auth/verify-email.
 */
export default function EmailVerificationBanner() {
  const { isVerified } = useVerification();

  if (isVerified !== false) return null;

  return (
    <InfoBanner size="lg">
      <p className="pb-2">
        <strong>Email not verified.</strong> Please verify your email to receive
        important updates about tickets, reservations, guest passes, and account
        security.{" "}
      </p>
      <Button href="/auth/verify-email" variant="accent">
        Verify my email
      </Button>
    </InfoBanner>
  );
}
